// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleSlice_wrapper__ic-I8","f-md":"TitleSlice_f-md__ueHXs","top":"TitleSlice_top__a+VYX","bottom":"TitleSlice_bottom__kFgHu"};